

import { createApp } from 'vue'
import { createI18n } from "vue3-i18n";
import App from './App.vue'
import router from './router'
import store from '@/store'
import swal from "./plugins/swal";
import axios from 'axios';
import '@/services/axios/interceptors'
require('@/store/subscriber');
import Vue3FormWizard from 'vue3-form-wizard'
import 'vue3-form-wizard/dist/style.css'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { FontAwesomeIcon } from './plugins/font-awesome'

/*
Components
*/
import Delete from '@/components/buttons/Delete.vue';
import Edit from '@/components/buttons/Edit.vue';
import Default from '@/components/buttons/Default.vue';
import DateField from './components/inputsValidation/DateField.vue'
import DateRangeField from './components/inputsValidation/DateRangeField.vue'
import PhoneNumber from './components/inputsValidation/PhoneNumber.vue'
import inputImage from './components/inputsValidation/inputImage.vue'
import PriceInput from './components/inputsValidation/inputPrice.vue'


/**
 * USERS
 */
import modalAddUser from './components/user/add.vue'
import modalResetPassword from './components/user/reset_password.vue'
import userCard from './components/user/card.vue'



import ChartDoughnut from './components/chartVue/ChartDoughnut.vue'
import ChartBar from './components/chartVue/ChartBar.vue'
import ChartLine from './components/chartVue/ChartLine.vue'

import NotFound from './components/notfound.vue'
import Loader from './components/loader.vue'
import NoPermission from './components/NoPermission.vue'


axios.defaults.baseURL = process.env.VUE_APP_ROOT_API
store.commit('auth/loginSuccess', JSON.parse(localStorage.getItem('user')!))
let lang = localStorage.getItem('selectedLang') || 'fr'
lang = lang != '' ? lang : 'fr'
console.log('Lang : ' + lang)
const i18n = createI18n({
  locale: lang,
  messages: {
    fr: require('@/i18n/fr.json'),
    en: require('@/i18n/en.json')
  }
});
const app = createApp(App)
app.use(router)
app.use(store)
app.use(swal);
app.use(i18n);
app.use(Vue3FormWizard)

app.component('btn-delete', Delete);
app.component('btn-edit', Edit);
app.component('btn-default', Default);

app.component('date-field', DateField);
app.component('daterange-field', DateRangeField);
app.component('phone-number', PhoneNumber);
app.component('input-image', inputImage);
app.component('price-input', PriceInput);


app.component('VueDatePicker', VueDatePicker);
app.component('doughnut-chart', ChartDoughnut);
app.component('bar-chart', ChartBar);
app.component('line-chart', ChartLine);

app.component('no-permission', NoPermission);
app.component('not-found', NotFound);
app.component('loader-gif', Loader);


/**
 * USERS
 */
app.component('modal-add-user', modalAddUser);
app.component('modal-reset-password', modalResetPassword);
app.component('user-card', userCard);


app.component("font-awesome-icon", FontAwesomeIcon)




// Check localStorage and import the appropriate style
const style = localStorage.getItem('style') ?? 'ltr';
import '@/sass/styles/theme_ltr/style.scss'
// if (style === 'ltr') {
//   import('@/sass/styles/theme_ltr/style.scss').then(() => {
//     document.body.classList.add('ltr');
//   });
// } else if (style === 'rtl') {
//   import('@/sass/styles/theme_rtl/style.scss').then(() => {
//     document.body.classList.add('rtl');
//   });
// }


app.mount('#app')